const VERSION_9 = "9";
const VERSION_10 = "10";
const VERSION_11 = "11";
const VERSION_12 = "12";
const VERSION_13 = "13";
const VERSION_15 = "15";
const VERSION_16 = "16";
const DEFAULT_VERSION = VERSION_15;
const ALLOWED_VERSIONS = [
    VERSION_9,
    VERSION_10,
    VERSION_11,
    VERSION_12,
    VERSION_13,
    VERSION_15,
    VERSION_16
];
module.exports = {
    VERSION_9,
    VERSION_10,
    VERSION_11,
    VERSION_12,
    VERSION_13,
    VERSION_15,
    VERSION_16,
    DEFAULT_VERSION,
    ALLOWED_VERSIONS
};
